<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="section-title">{{ isEditMode() ? 'Editar Rubro' : 'Nuevo Rubro' }}</h1>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Modifica la información del rubro' : 'Completa los datos para crear un nuevo rubro' }}
        </p>
      </div>
      <div class="flex gap-2">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-outlined"
          (click)="onCancel()"
          [disabled]="loading()">
        </button>
        <button
          pButton
          type="button"
          [label]="isEditMode() ? 'Guardar Cambios' : 'Crear Rubro'"
          [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-plus'"
          class="p-button"
          (click)="onSubmit()"
          [disabled]="loading() || rubroForm.invalid"
          [loading]="loading()">
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="app-page-content">
    <form [formGroup]="rubroForm" (ngSubmit)="onSubmit()" id="rubroForm">
      <div class="app-card">
        <!-- Form Title -->
        <h2 class="text-xl font-semibold mb-6" style="color: hsl(var(--text));">
          {{ isEditMode() ? 'Datos del Rubro' : 'Datos Generales' }}
        </h2>

        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
          <!-- Código -->
          <div class="space-y-2">
            <label for="codigo" class="text-sm font-medium" style="color: hsl(var(--text));">
              Código *
            </label>
            <input
              pInputText
              id="codigo"
              formControlName="codigo"
              type="text"
              placeholder="Ej: AUTO"
              class="w-full"
              [class.border-red-500]="rubroForm.get('codigo')?.invalid && rubroForm.get('codigo')?.touched"
            />
            @if (rubroForm.get('codigo')?.hasError('required') && rubroForm.get('codigo')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Código es requerido
              </small>
            }
            @if (rubroForm.get('codigo')?.hasError('maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Código no puede exceder 255 caracteres
              </small>
            }
            @if (rubroForm.get('codigo')?.hasError('server')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ rubroForm.get('codigo')?.getError('server') }}
              </small>
            }
          </div>

          <!-- Nombre -->
          <div class="space-y-2">
            <label for="nombre" class="text-sm font-medium" style="color: hsl(var(--text));">
              Nombre *
            </label>
            <input
              pInputText
              id="nombre"
              formControlName="nombre"
              type="text"
              placeholder="Ej: Automotriz"
              class="w-full"
              [class.border-red-500]="rubroForm.get('nombre')?.invalid && rubroForm.get('nombre')?.touched"
            />
            @if (rubroForm.get('nombre')?.hasError('required') && rubroForm.get('nombre')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Nombre es requerido
              </small>
            }
            @if (rubroForm.get('nombre')?.hasError('maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Nombre no puede exceder 255 caracteres
              </small>
            }
            @if (rubroForm.get('nombre')?.hasError('server')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ rubroForm.get('nombre')?.getError('server') }}
              </small>
            }
          </div>

          <!-- Descripción -->
          <div class="space-y-2 md:col-span-2">
            <label for="descripcion" class="text-sm font-medium" style="color: hsl(var(--text));">
              Descripción
            </label>
            <textarea
              pTextarea
              id="descripcion"
              formControlName="descripcion"
              placeholder="Descripción del rubro"
              class="w-full"
              rows="3"
              [class.border-red-500]="rubroForm.get('descripcion')?.invalid && rubroForm.get('descripcion')?.touched">
            </textarea>
            @if (rubroForm.get('descripcion')?.hasError('maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Descripción no puede exceder 255 caracteres
              </small>
            }
            @if (rubroForm.get('descripcion')?.hasError('server')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ rubroForm.get('descripcion')?.getError('server') }}
              </small>
            }
          </div>

          <!-- Estado Activo -->
          <div class="space-y-2 md:col-span-2">
            <div class="flex items-center justify-between p-4 rounded-lg" style="background-color: hsl(var(--surface-2));">
              <div>
                <label for="active" class="text-sm font-medium" style="color: hsl(var(--text));">
                  Rubro Activo
                </label>
                <p class="text-sm text-muted mt-1">
                  Indica si el rubro está active en el sistema
                </p>
              </div>
              <p-toggleSwitch
                id="active"
                formControlName="active">
              </p-toggleSwitch>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
